export { default as Img200 } from './processed/200/Stardust.jpg';
export { default as Img400 } from './processed/400/Stardust.jpg';
export { default as Imgthumb } from './processed/thumb/Stardust.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Stardust.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Stardust.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      236,
      126,
      56
    ],
    "_population": 2215,
    "_hsl": [
      0.06481481481481481,
      0.8256880733944955,
      0.5725490196078431
    ]
  },
  "LightVibrant": {
    "_rgb": [
      249,
      212,
      122
    ],
    "_population": 674,
    "_hsl": [
      0.11811023622047245,
      0.9136690647482016,
      0.7274509803921568
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      10,
      48,
      104
    ],
    "_population": 519,
    "_hsl": [
      0.599290780141844,
      0.824561403508772,
      0.22352941176470587
    ]
  },
  "Muted": {
    "_rgb": [
      170,
      113,
      95
    ],
    "_population": 990,
    "_hsl": [
      0.03999999999999999,
      0.30612244897959173,
      0.5196078431372548
    ]
  },
  "LightMuted": {
    "_rgb": [
      186,
      154,
      134
    ],
    "_population": 2264,
    "_hsl": [
      0.06410256410256408,
      0.27368421052631575,
      0.6274509803921569
    ]
  },
  "DarkMuted": {
    "_rgb": [
      53,
      76,
      100
    ],
    "_population": 1419,
    "_hsl": [
      0.5851063829787234,
      0.3071895424836601,
      0.3
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Stardust.js